// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"374":"9f249659","377":"5fc8d1d1","381":"ff824ee0","433":"398549f6","495":"4908c624","565":"b5ebfe2a","579":"395a64cf","593":"2c1b7b99","643":"de9ea197","644":"7fb841cb","736":"38a1ee3b"}[chunkId] + ".js";
};